// removed by extract-text-webpack-plugin
module.exports = {"Card":"RestaurantCard__Card__3AgHB","LoadingContainer":"RestaurantCard__LoadingContainer__7VqxW","CardImg":"RestaurantCard__CardImg__3bsDW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/RestaurantCard/RestaurantCard.css
// module id = 121
// module chunks = 0